<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  background-color: #f5f5f5;
  color: #333;
  line-height: 1.5;
}
@media (min-width: 1000px) { /* 当父元素宽度大于600px时 */
  .container {
    width: 50%; /* 子元素宽度设为父元素宽度的50% */
  }
}
.container {
  margin: 0 auto;
  min-height: 100vh;
  background-color: white;
  position: relative;
}

.header {
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: white;
  padding: 20px 16px;
  position: relative;
  text-align: left;
  width: 100%;
}

.header h1 {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
}

.header .time {
  font-size: 14px;
  opacity: 0.9;
}

.content {
  padding: 20px 16px;
}

.qr-section {
  text-align: center;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.qr-title {
  font-size: 18px;
  color: #409EFF;
  margin-bottom: 15px;
  font-weight: 500;
}

.qr-code-placeholder {
  width: 100%;
  padding: 20px;
  margin: 0 auto 15px;
  /*background-color: #f0f0f0;*/
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  border: 1px dashed #ddd;
}

.qr-note {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.visitor-note{
  font-size: 14px;
  color: #f5743f;
  width: 100%;
  background-color: #fae2cf;
  padding: 10px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  border-radius: 8px;
}

.info-card {
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border-left: 4px solid #409EFF;
}

.info-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.info-item {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
}

.info-label {
  color: #666;
  width: 100px;
  flex-shrink: 0;
}

.info-value {
  color: #333;
  flex: 1;
}

.password-section {
  text-align: center;
  margin-top: 25px;
}

.password-title {
  font-size: 16px;
  color: #409EFF;
  margin-bottom: 15px;
  font-weight: 500;
}

.password-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  margin: 0 auto 20px;
  width: 100%;
}

.password-digit {
  height: 30px;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  background-color: #f0f0f0;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.warning-text {
  color: #f56c6c;
  font-size: 14px;
  text-align: center;
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-text i {
  margin-right: 5px;
}

.footer {
  padding: 20px 16px;
  text-align: center;
  display: none;
}

.action-btn {
  width: 100%;
  margin-bottom: 15px;
}

.tip-box {
  background-color: #f5dfd6;
  border-radius: 8px;
  padding: 12px 15px;
  margin-bottom: 20px;
  border-left: 3px solid #ff7240;
}

.tip-title {
  font-size: 14px;
  color: #ff7240;
  margin-bottom: 5px;
  font-weight: 500;
}

.tip-content {
  font-size: 13px;
  color: #666;
}

.status-badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: #67c23a;
  color: white;
  border-radius: 20px;
  font-size: 12px;
  margin-left: 10px;
}

.expiry-info {
  background-color: #fff6f6;
  border-radius: 8px;
  padding: 12px 15px;
  margin: 20px 0;
  border-left: 3px solid #f56c6c;
  font-size: 14px;
}

.expiry-label {
  color: #f56c6c;
  font-weight: 500;
}

.expiry-value {
  color: #333;
  margin-left: 5px;
}

.visitor-name {
  font-size: 22px;
  font-weight: 500;
  color: #333;
  text-align: center;
  margin: 20px 0;
}
/*
@media (max-width: 375px) {
  .password-digit {
    height: 50px;
    font-size: 20px;
  }

  .header h1 {
    font-size: 18px;
  }

  .qr-code-placeholder {
    width: 180px;
    height: 180px;
  }
}*/

.visitor-info {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.info-item {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.info-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.info-label {
  font-size: 14px;
  color: #666;
}

.info-value {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  text-align: right;
}

.info-value.highlight {
  color: #1e88e5;
}
</style>

<template>
  <div class="container">
    <!-- 头部 -->
    <div class="header">
      <h1>您好</h1>
      <div class="time">欢迎来访「{{ visitorInfo?.company?.name }}」</div>
    </div>

    <!-- 内容区域 -->
    <div class="content">
      <!-- 初始状态：生成二维码/密码 -->
      <div class="tip-box">
        <div class="tip-title">🔒 请使用【{{ transportationMethod.join('/') }}】通行</div>
        <div class="tip-content">小贴士：请妥善保管您的通行凭证，不要泄露给无关人员</div>
      </div>

      <div class="visitor-info">
        <div class="info-item">
          <div class="info-label">姓名</div>
          <div class="info-value">{{ visitorInfo?.visitor }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">手机号</div>
          <div class="info-value">{{ visitorInfo?.phoneNum }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">设备编号</div>
          <div class="info-value highlight">{{ visitorInfo?.deviceNumber || '-' }}</div>
        </div>
      </div>


      <div class="password-section" v-if="visitorInfo.password">
<!--        <div class="password-title">通行密码</div>-->
        <div class="password-grid">
          <div class="password-digit" v-for="(digit, index) in passwordDigits" :key="index">{{ digit }}</div>
        </div>
      </div>
      <div class="visitor-note" v-if="visitorInfo.password || visitorInfo.qrcode">
        <span>请</span>
        <span v-if="visitorInfo.qrcode">扫描下方二维码</span>
        <span v-if="visitorInfo.password && visitorInfo.qrcode">或</span>
        <span v-if="visitorInfo.password">使用上方数字密码</span>通行</div>
      <div class="qr-section" v-if="visitorInfo.qrcode">
        <div class="qr-title">访客二维码</div>
        <template v-if="visitorInfo.qrcode">
          <div class="qr-code-placeholder">
              <canvas  ref="canvas_visitor_ref" style="width: 100%;height: 100%" @click="refreshQrcode"></canvas>
          </div>
          <div class="qr-note">二维码有效期30分钟，点击二维码刷新</div>
        </template>
        <span v-else>请稍候...</span>
      </div>



      <div class="visitor-info">
        <div class="info-item">
          <div class="info-label">被访人</div>
          <div class="info-value">{{ visitorInfo?.user?.name }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">被访人手机号</div>
          <div class="info-value">{{ visitorInfo?.user?.phone }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">预约到访时间</div>
          <div class="info-value highlight">{{ visitorInfo.visitDate }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">预计离访时间</div>
          <div class="info-value highlight">{{ visitorInfo.visitEndDate }}</div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer">
      <el-button
          type="danger"
          class="action-btn"
          @click="cancelReservation"
      >
        取消预约
      </el-button>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import logo from '@/assets/visitor/comte.png';

export default {
  components: {},
  props: {
    visitorInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      expired: false,
      logoUrl: logo,
      passwordDigits: [],
      transportationMethod: ['人脸','二维码','密码','卡片']
    }
  },
  computed: {

  },
  watch: {
    visitorInfo: function (newValue, oldValue) {
      if (newValue) {
        this.init()
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      this.generateVisitorQrCode(this.visitorInfo.qrcode, 'canvas_visitor_ref');
      if(this.visitorInfo.password){
        this.passwordDigits = (this.visitorInfo.password+'').split('');
      }
    },
    cancelReservation() {
      this.$confirm('确定要取消预约吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '预约已取消'
        });
      }).catch(() => {
        // 用户点击取消
      });
    },
    async generateVisitorQrCode(text,id) {
      if(text){
        this.$nextTick(async() => {
          try {
            const qrSize = 240; // QR Code 的尺寸
            const qrDataUrl = await QRCode.toDataURL((text), {
              width: qrSize,
              height: qrSize,
              margin: 1,
              errorCorrectionLevel: 'H'
            });
            const canvas = this.$refs[id];
            const ctx = canvas.getContext('2d');

            canvas.width = qrSize;
            canvas.height = qrSize;
            // 绘制二维码
            const img = new Image();
            img.src = qrDataUrl;
            img.onload = () => {
              ctx.drawImage(img, 0, 0, qrSize, qrSize);
              // 清理 logo 周围的区域
              const centerX = qrSize / 2;
              const centerY = qrSize / 2;
              ctx.globalCompositeOperation = 'destination-out'; // 设置为擦除模式
              ctx.beginPath();
              ctx.arc(centerX, centerY, 0, 0, Math.PI * 2); // 清理圆区域
              ctx.fill();
              ctx.globalCompositeOperation = 'source-over'; // 恢复正常模式
              // 绘制 logo
              const logo = new Image();
              logo.src = this.logoUrl;
              logo.onload = () => {
                const logoSize = qrSize / 5; // logo 的尺寸
                const logoX = centerX - logoSize / 2; // logo 的 X 坐标
                const logoY = centerY - logoSize / 2; // logo 的 Y 坐标
                ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);
              };
            };
          } catch (err) {
            console.error('Error generating QR code:', err);
          }
        })
      }
    },
    refreshQrcode(){
      this.$emit('refresh');
    }
  },
}
</script>
